// extracted by mini-css-extract-plugin
export var icon = "_8-1";
export var subtext = "_8-0";